import React, { Component } from "react";
import Footer from "../../components/footer.component";
import Header from "../../components/header.component";
import "../../css/error-page.css";
import reportVisitService from "../../reporting-visit/report-visit.service";

export default class NotFoundPage extends Component {
  componentDidMount() {
    document.title =
      "Not found | David Šimák - A self-taught JAVA/Kotlin developer";
    reportVisitService.report(window.location.pathname, document.title);
  }

  render() {
    return (
      <div>
        <Header customColor="#424242" lightColor={true} />

        <div class="error-overview">
          <div className="error-overview-title-container">
            <label className="error-overview-title">Not found</label>
          </div>
          <h2>
            Hmmm... It's looks like that the page you are looking does not
            exists.
          </h2>
          <h4>
            But you can learn something{" "}
            <a className="text-bold-background" href="/about">
              about me
            </a>
            <br />
            or explore{" "}
            <a className="text-bold-background" href="/projects">
              some of my projects
            </a>
          </h4>
        </div>

        <Footer />
      </div>
    );
  }
}
